import { ReportingControllerBaseConfig } from '../../base';
import { CalloutController } from './calloutBlockInterface';
import { CalloutBlockViewProps } from './calloutBlockProps';
import { createBlockItemController } from '../block';

export function createCalloutController(
    config: ReportingControllerBaseConfig
): CalloutController {
    const blockController = createBlockItemController();
    return {
        useProps(context, item, props): Omit<CalloutBlockViewProps, 'children'> {
            const block = blockController.useProps(context, item, props.item);
            return {
                block,
                icon: props.icon,
            };
        },
    };
}
